import styles from './ShowFeaturesWindow.module.scss';
import ModalWindow from '../ModalWindow';
import { useDispatch } from 'react-redux';
import { setModalWindowData } from '../../../redux/reducers/pageSlice';
import { ModalWindowTypes } from '../../../utils/@globalTypes';
import FeaturesList from '../../FeaturesList';

const ShowFeaturesWindow = ({ data }: any) => {
  const dispatch = useDispatch();

  if (!data) {
    dispatch(setModalWindowData({ type: ModalWindowTypes.CLOSE }));
    return null;
  }

  return (
    <ModalWindow
      isLoading={false}
      isFullCustom
      hideCross
      windowClassname={styles.window}
    >
      <FeaturesList list={data.list} setList={data.setList} />
    </ModalWindow>
  );
};

export default ShowFeaturesWindow;
